import Vue from 'vue';
import VueCookie from 'vue-cookie';
import sha256 from 'js-sha256';
import base64 from 'base-64';
import utf8 from 'utf8';

Vue.use(VueCookie, sha256, base64, utf8);

export default {
  methods: {
    triggerMessageModal(id) {
      let vm = this;
      jQuery(id).modal('show');
      setTimeout(() => {
        vm.clear();
        jQuery(id).modal('hide');
      }, 5000);
    },
    prepareDataTable(id) {
      setTimeout(
        function(){
          jQuery(id).DataTable({
            pageLength: 5,
            lengthMenu: [[5, 10, 15, 20], [5, 10, 15, 20]],
            autoWidth: false
          });
        },
        100
      );
    },
    finishLogout(message) {
      let vm = this;
      if (message) {
        vm.error(message);
        vm.triggerMessageModal('#alert_modal');
      }
      localStorage.clear();
      vm.$router.push('/login');
    },
    getAuthHeader() {
      let sId = Vue.cookie.get('PHPSESSID'),
        header = {'Content-Type': 'application/json'};
      if (typeof localStorage.token !== 'undefined' && typeof sId !== 'undefined') {
        var hash = sha256.create();
        hash.update(utf8.decode(base64.decode(localStorage.token)) + ':gt:' + sId);
        header.Authorization = 'Bearer ' + hash.hex();
        return header;
      }
      return header;
    },
    showLogin(response) {
      return (typeof response.data !== 'undefined') &&
        (typeof response.data.authStatus !== 'undefined');
    },
    loadFile(filename, filetype){
      var fileref = null;
      if (filetype === 'js') {
        fileref = document.createElement('script');
        fileref.setAttribute('type','text/javascript');
        fileref.setAttribute('src', filename);
      } else if (filetype === 'css') {
        fileref = document.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filename);
      }

      if (typeof fileref !== 'undefined') {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      }
    },
    removeFile(filename, filetype) {
      let targetelement = (filetype === 'js') ? 'script' : (filetype === 'css')? 'link' : 'none';
      let targetattr = (filetype === 'js') ? 'src' : (filetype === 'css') ? 'href' : 'none';
      let allsuspects = document.getElementsByTagName(targetelement);
      for (let i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
        if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) !== null && allsuspects[i].getAttribute(targetattr).indexOf(filename)!== -1) {
          allsuspects[i].parentNode.removeChild(allsuspects[i]);
        }
      }
    }
  }
};


// WEBPACK FOOTER //
// ./source/mixins/handler.js